import { gql, useMutation } from '@apollo/client'
import ActionModal from 'components/Dashboard/ActionModal'
import TextInput from 'components/TextInput'
import mutationResponseToToast, { mutationResponseFragment } from './mutationResponseToToast'
import {
  ChangeVideoSupervisionCreditsMutation,
  ChangeVideoSupervisionCreditsMutationVariables,
} from './__generated__/ChangeVideoSupervisionCreditsMutation'

const changeVideoSupervisionCreditsMutation = gql`
  mutation ChangeVideoSupervisionCreditsMutation($input: ChangeVideoCreditsInput!) {
    changeVideoSupervisionCredits(input: $input) {
      order {
        id
        videoSupervisionCredits
      }

      ...MutationResponseFragment
    }
  }

  ${mutationResponseFragment}
`

interface FormValues {
  videoSupervisionCredits: number
  reason: string
  zdRef: string
}

interface ChangeOrderEmailModalProps {
  orderId: string
  initialCredits: number
  onRequestClose: () => void
}

const ChangeOrderEmailModal = ({ orderId, initialCredits, onRequestClose }: ChangeOrderEmailModalProps) => {
  const [changeVideoSupervisionCredits] = useMutation<
    ChangeVideoSupervisionCreditsMutation,
    ChangeVideoSupervisionCreditsMutationVariables
  >(changeVideoSupervisionCreditsMutation)

  return (
    <ActionModal<FormValues>
      header="Change Video Supervision Credits"
      formikInitialValues={{
        videoSupervisionCredits: initialCredits,
        reason: '',
        zdRef: '',
      }}
      onSubmit={async (values, { addToast }) => {
        const resp = await changeVideoSupervisionCredits({
          variables: {
            input: {
              orderId,
              videoSupervisionCredits: +values.videoSupervisionCredits,
              reason: values.reason,
              zdRef: values.zdRef,
            },
          },
        })

        if (!resp.data.changeVideoSupervisionCredits.success) {
          throw new Error(resp.data.changeVideoSupervisionCredits.message || 'Something went wrong')
        }

        addToast(mutationResponseToToast(resp.data.changeVideoSupervisionCredits))
      }}
      onRequestClose={onRequestClose}
      submitText="Change Video Supervision Credits"
    >
      <TextInput name="videoSupervisionCredits" label={`Credits (was: "${initialCredits}")`} />
      <TextInput name="reason" label="Reason for change (optional)" />
      <TextInput name="zdRef" label="Zendesk ticket no (if applicable)" />
    </ActionModal>
  )
}

export default ChangeOrderEmailModal
